const id_master_bankaccount = {
    "": "rekening bank",
    bank: "bank",
    norek: "nomor rekening",
    namerek: "nama rekening",
    add: "tambah rekening bank",
    edit: "ubah rekening bank",

    error: {
        bank: "Bank tidak boleh kosong.",
        norek: "Nomor rekening tidak boleh kosong.",
        namerek: "Nama rekening tidak boleh kosong.",
        create: "Gagal membuat rekening.",
        delete: "Gagal menghapus rekening.",
        edit: "Gagal mengubah rekening.",
    },

    success: {
        create: "Berhasil membuat rekening.",
        delete: "Berhasil menghapus rekening.",
        edit: "Berhasil mengubah rekening.",
    }
}

export default id_master_bankaccount;